import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { OpeningHookSection } from '../components/OpeningHookSection';
import { WhatYouTriedSection } from '../components/WhatYouTriedSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full overflow-hidden selection:bg-sage selection:text-cream" data-id="element-238">
      <HeroSection data-id="element-239" />
      <OpeningHookSection data-id="element-240" />
      <WhatYouTriedSection data-id="element-241" />
      <MechanismSection data-id="element-242" />
      <WhatYouGetSection data-id="element-243" />
      <HowItWorksSection data-id="element-244" />
      <ForWhomSection data-id="element-245" />
      <ProofSection data-id="element-246" />
      <FAQSection data-id="element-247" />
      <PricingSection data-id="element-248" />
      <FinalCTA data-id="element-249" />
      <Footer data-id="element-250" />
    </main>;
}